import { CashRequestOptions, post } from '@cash-web/shared-util-fetch'
import { RefundPaymentRequest } from '@cash-web/shared-util-protos/squareup/franklin/app.pb'
import { RefundPaymentResponse } from '@cash-web/shared-util-protos/squareup/franklin/app.pb'

export const refundPayment = (request: RefundPaymentRequest, options?: CashRequestOptions) =>
  post<RefundPaymentRequest, RefundPaymentResponse>('/2.0/cash/refund-payment', request, {
    ...options,
    rejectOnError: true,
  })
